import Box from "@mui/material/Box";
import { type SxProps } from "@mui/system";
import { useMemo } from "react";
import useIsMobile from "../../../../../../hooks/device/useIsMobile";
import type { GuidedMode } from "../../../entities/survey-step";
import { DrawerHtmlWrapper } from "../drawer-html-wrapper";
import { GuidedModeExample } from "../guided-mode-example";
import { getDrawerContentStylesByDevice } from "./utils/get-drawer-content-styles-by-device";

interface DrawerContentProps {
  guidedMode: GuidedMode;
}

export function DrawerContent({ guidedMode }: Readonly<DrawerContentProps>): JSX.Element {
  const isMobile = useIsMobile();

  const contentStyles: SxProps = useMemo(
    function memoizeStyles() {
      const styles: SxProps = getDrawerContentStylesByDevice(isMobile);
      return styles;
    },
    [isMobile]
  );

  return (
    <Box sx={contentStyles}>
      <DrawerHtmlWrapper html={guidedMode.description} />
      {guidedMode.example && <GuidedModeExample example={guidedMode.example} />}
    </Box>
  );
}
